let baseUrl = process.env.BASE_UTL;

let routerMode = 'hash';
let baseImgPath;
let timeout=50000;

// 根据当前环境自动设置商户后台 URL
let merchantBaseUrl;

// 从 BASE_UTL 中判断当前环境
if (baseUrl) {
  // 检查 BASE_UTL 中包含的域名
  if (baseUrl.includes('siapcn-stg-admin')) {
    // STG管理员环境
    merchantBaseUrl = 'https://cgp-siapcn-stg.local.opentide.com.cn';
  } else if (baseUrl.includes('local.opentide.com.cn')) {
    // 开发/测试环境
    merchantBaseUrl = 'https://siapcn.local.opentide.com.cn';
  } else if (baseUrl.includes('cgp-siapcn.galaxyappstore.com')) {
    // 管理员正式环境
    merchantBaseUrl = 'https://siapcn.galaxyappstore.com';
  } else if (baseUrl.includes('galaxyappstore.com')) {
    // 商户正式环境
    merchantBaseUrl = 'https://siapcn.galaxyappstore.com';
  } else {
    // 默认情况，从当前 URL 中提取
    const url = new URL(baseUrl);
    merchantBaseUrl = `${url.protocol}//${url.hostname}`;
  }
} else {
  // 默认商户后台 URL（开发环境）
  merchantBaseUrl = 'https://siapcn.local.opentide.com.cn';
}

export {
	baseUrl,
	routerMode,
	baseImgPath,
  timeout,
	merchantBaseUrl
}




// WEBPACK FOOTER //
// ./src/config/env.js